<template>
    <div class="helper-control" @mouseenter="visible = true" @mouseleave="visible = false">
        <img src="https://rdgta.cdn.cyagen.com/rddc/images/controls/icon3.png" class="helper-icon" />
        <img src="https://rdgta.cdn.cyagen.com/rddc/images/controls/icon3-active.png" class="helper-icon helper-icon-active" />
        <div class="helper-context">{{ $t("Comparison") }}</div>

        <transition v-on="animations.tooltip()">
            <div class="comparison-helper-tooltip" v-if="visible">
                <template v-for="value in options">
                    <project-route class="comparison-btn" :to="value.route" v-if="value.visible">
                        <ui-tooltip-follow v-bind="binds.tooltip">
                            <ui-icon :name="value.icon" class="comparison-btn-icon" />
                            <div class="comparison-btn-text">{{ value.name }}</div>
                            <template #content>
                                {{ value.name }}
                            </template>
                        </ui-tooltip-follow>
                    </project-route>
                </template>
            </div>
        </transition>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon, UiTooltipFollow } from "various-ui";
import { animations } from "various-ui";
//* 组件属性
import { useComposable } from "./src/composable";

const { refs, options, watchs, binds } = useComposable();
const { visible } = refs;

onBeforeUnmount(() => {
    watchs.stopRouteWatch && watchs.stopRouteWatch();
});
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
